export default function defineTitreIntervenant(intervenant) {
  const tabLibelleTitreIntervenant = [];
  tabLibelleTitreIntervenant.push('Annonceur');
  tabLibelleTitreIntervenant.push('Mandataire payeur');
  tabLibelleTitreIntervenant.push('Mandataire non payeur');
  tabLibelleTitreIntervenant.push('Donneur d\'ordre');

  if (intervenant.titre !== null && tabLibelleTitreIntervenant.some((libelle) => {
    return intervenant.titre === libelle;
  })) {
    intervenant.titre = null;
  }
  if (intervenant.titre) {
    return;
  }

  if (intervenant.annonceur) {
    intervenant.titre = 'Annonceur';
    return;
  }

  if (intervenant.mandataire) {
    if (intervenant.payeur) {
      intervenant.titre = 'Mandataire payeur';
    } else {
      intervenant.titre = 'Mandataire non payeur';
    }
    return;
  }

  if (intervenant.donneurOrdre) {
    intervenant.titre = 'Donneur d\'ordre';
  }
}
